import type { SceneData } from '../types'

export interface SpacingManagerContext {
  wrapper: HTMLDivElement | null
  imageContainer: HTMLDivElement | null
  data: SceneData
}

function getImageHeight(imageContainer: HTMLDivElement): number {
  const img = imageContainer.querySelector('img')
  return img?.getBoundingClientRect().height ?? imageContainer.getBoundingClientRect().height
}

export function applySpacing(context: SpacingManagerContext): void {
  const { wrapper, imageContainer, data } = context
  if (!imageContainer || !wrapper) return
  if (!data.padding && !data.margin) return

  const imageHeight = getImageHeight(imageContainer)
  if (imageHeight <= 0) return

  if (data.padding) {
    if (data.padding.top !== undefined) {
      wrapper.style.paddingTop = `${(data.padding.top / 100) * imageHeight}px`
    }
    if (data.padding.bottom !== undefined) {
      wrapper.style.paddingBottom = `${(data.padding.bottom / 100) * imageHeight}px`
    }
  }

  if (data.margin) {
    if (data.margin.top !== undefined) {
      wrapper.style.marginTop = `${(data.margin.top / 100) * imageHeight}px`
    }
    if (data.margin.bottom !== undefined) {
      wrapper.style.marginBottom = `${(data.margin.bottom / 100) * imageHeight}px`
    }
  }
}

export function setupSpacingResizeListener(context: SpacingManagerContext, onResize: () => void): (() => void) | null {
  const { data } = context
  if (!data.padding && !data.margin) return null

  window.addEventListener('resize', onResize)
  return () => window.removeEventListener('resize', onResize)
}
